export default __webpack_public_path__ + "static/media/hero.9e31413f.png";